<template>
  <div class="modal-mask" @click="close" v-show="show" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container" @click.stop>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: ["show", "onClose"],
  methods: {
    close() {
      this.onClose();
    },
  },
  // ready() {
  //     document.addEventListener("keydown", (e) => {
  //         if (this.show && e.keyCode == 27) {
  //             this.onClose();
  //         }
  //     });
  // }
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.modal-container {
  width: 300px;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-enter,
.modal-leave {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* FIXME - Where do these styles go? Do we like this layout/concept for modal editing? */

.modal-header h3 {
  margin-top: 0;
  color: #3498db;
}

.modal-body {
  margin: 20px 0;
}

.text-right {
  text-align: right;
}

.form-label {
  display: block;
  margin-bottom: 1em;
  color: #888;
}

.form-label > .form-control {
  margin-top: 0.5em;
}

.form-control {
  display: inline-block;
  /*width: 100%;*/
  font-size: 1rem;
  line-height: 1.5;
  border: none;
  border-bottom: 1px solid #ddd;
  transition: border 500ms ease-out;
}

.form-control:focus {
  outline: none;
  border-bottom: 1px solid #3498db;
}

/* FIXME - THIS IS NOT THE RIGHT SOLUTION - COLOR PICKER PLEASE */
select.form-control {
  background: transparent;
  text-align-last: right;
  width: 11rem;
}

.modal-default-button {
  border: 1px solid #ddd;
  background-color: transparent;
  padding: 0.25rem 0.5rem;
  width: 4rem;
  transition: border 500ms ease-out;
}

.modal-default-button:hover,
.modal-default-button:focus {
  border: 1px solid #3498db;
  outline: none;
}

/* FIXME - Make this a more generic flex style */
.modal-footer {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// Modal.vue?f771f19e